<template>
  <v-app-bar flat fixed dark color="primary">
    <v-icon @click="goBack">
      fas fa-arrow-left
    </v-icon>
    <v-spacer />
    <v-toolbar-title @click="gotoHome">
      <v-img src="assets/imgs/logo-negative.svg" />
    </v-toolbar-title>
    <v-spacer />
    <template v-if="$slots.default" v-slot:extension>
      <slot></slot>
    </template>
  </v-app-bar>
</template>

<script>
export default {
  methods: {
    gotoHome () {
      this.$router.goToHome(this.$route.path)
    },
    goBack () {
      this.$emit('close')
    }
  }
}
</script>
